import React from 'react';
import './FillWordLetter.css';

class Letter extends React.Component {
  render () {
    let size = this.props.size || 64;

    let style = {
      width: size,
      height: size,
      lineHeight: `${Math.round(size * 0.9)}px`,
      fontSize: `${Math.round(size*0.7)}px`,
      borderWidth: Math.ceil(0.03 * size),
    };

    if(this.props.bgColor) {
      style.backgroundColor = this.props.bgColor;
    }

    return (
      <div
        onMouseEnter={this.props.mouseEnter}
        className="fillword-letter"
        style={style}
        data-key={this.props.slug}
      >
        { this.props.Letter }
      </div>
    )
  }
}

export default Letter;